<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="jmgrandbleu_breadcrumb" />
    </div>

    <div class="outterBox">
      <div class="header">
        <!--      <h1 class="overlay">SPECIAL SOUVENIR</h1>-->
        <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
        <div class="headerimage" />
      </div>

      <div class="container contentDesc">
        <div class="title1">
          <div class="titleDesc col-lg-12 text-center">
            <h4 style="color: #b9b1b1">푸른 바다를 품은 제주 럭셔리 요트 투어</h4>
          </div>
          <h2>
            <strong>제이엠 그랑블루 요트</strong>
          </h2>
        </div>
      </div>
      <div class="container">
        <div class="row d-flex justify-content-center">
          <!--          <div>-->
          <!--            &lt;!&ndash;          <div class="overlay"><h1>SPECIAL BENEFITS</h1></div>&ndash;&gt;-->
          <!--            <img src="@/assets/images/Podohotel/benefitinfo_headerimage.png" />-->
          <!--          </div>-->
          <!--          <div class="wedding_body_hedaer text-center col-lg-12 mt-5 mb-4">-->
          <!--            <h2><strong>제이엠 그랑블루 요트</strong></h2>-->
          <!--          </div>-->

          <img class="imageStyle" src="@/assets/images/Podohotel/benefitinfo_bodyimage02.jpg" />
        </div>

        <div class="row d-inline-block pt-5 pb-5 p-2">
          <div class="mb-5">
            <h5 style="line-height: 2">
              주식회사 제이엠 그랑블루요트는 대포포구에 위치한 요트투어 관광지로 47인승, 44인승 요트를 보유하여<br />
              동시에 최대 91명까지 승선이 가능합니다. 럭셔리투어 소요시간은 1시간으로 대포항에서 출항하여 월평동굴 및
              럭셔리투어 소요시간은 1시간으로 대포항에서 출항하여 월평동굴 및 주상절리를 항해하는 차별화된 코스를
              운영하고 있습니다. 요트투어를 하시는 동안 세일링, 낚시를 하실 수 있을 뿐만 아니라 계절별 특별메뉴<br />
              (동절기-어묵, 컵라면 특별제공)와 와인, 생맥주, 쿠키, 원두커피가 제공되며 노래방 시설, 화장실 등 편의시설이
              완비되어 있습니다.
            </h5>
          </div>
          <hr />
          <table class="table table-borderless mt-5 mx-auto col-lg-8 col-12">
            <tbody>
              <tr class="d-flex flex-column mb-4">
                <td><h5>할인혜택</h5></td>
                <td><h5>투숙객 이용료 30% 할인</h5></td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td><h5>이용방법</h5></td>
                <td><h5>사전 전화 예약 후, 승선 20분 전까지 신분증과 함께 방문</h5></td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td><h5>주소</h5></td>
                <td><h5>서귀포시 대포로 172-7</h5></td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td><h5>문의번호</h5></td>
                <td><h5>064-739-7776</h5></td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td><h5>홈페이지</h5></td>
                <td>
                  <h5>SNS <a href=" https://www.instagram.com/gb.jeju">instagram.com/gb.jeju</a></h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Jmgrandbleu',
  data() {
    return {
      jmgrandbleu_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'AFFILIATE BENEFIT GUIDE',
        present: '제이엠 그랑블루 요트',
      },
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: '제이엠 그랑블루 요트'});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.table h5 {
  margin: 0;
}
.table td {
  padding: 5px;
}

h5 {
  word-break: keep-all;
}

.main-ex-desc {
  vertical-align: bottom;
}

.header {
  position: relative;
  width: 100%;
  padding-top: 0rem;
  > img {
    width: 100%;
  }

  .overlay {
    padding-top: 0rem;
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }

  .headerimage {
    display: block;
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/benefitinfo_headerimage.png');
  }
}

.contentDesc {
  padding-top: 3rem;
  padding-bottom: 3rem;
  text-align: center;
}

.outterBox {
}

@media (max-width: 992px) {
  .header {
    display: none;
  }
  .outterBox {
    padding-top: 5rem;
  }

  h2 {
    font-size: 1.5rem !important;
  }

  h3 {
    font-size: 1.3rem !important;
  }

  h4 {
    font-size: 1rem !important;
  }

  h5 {
    line-height: 1.6rem !important;
    font-size: 1rem !important;
  }

  .imageStyle {
    width: 100%;
  }
}
</style>
